import { HOSPITAL_LAYOUT_MENU_TITLE_KEY } from 'views/panels/admin-panel/HospitalLayout/hospital-layout.menuI18n'

const SUPER_ADMIN_PATH = '/super-admin/'
const ADMIN_PANEL_SEGMENT = '/admin-panel/'
const DEVICE_GATEWAY_PATH = '/admin-panel/device-gateway'
const HOSPITAL_LAYOUT_PATH = '/admin-panel/hospital-layout'
const SEQ_STEP = 0.01
const FALLBACK_ICON = { icon: 'map', iconSource: 'feather', iconType: 'icon' }

const childrenOf = (items) => (Array.isArray(items) ? items : [])
const pathOf = (item) =>
  String(item?.url || '')
    .split('?')[0]
    .replace(/\/$/, '')
const isSuperAdminPanel = (item) =>
  pathOf(item).startsWith(SUPER_ADMIN_PATH) &&
  pathOf(item).includes(ADMIN_PANEL_SEGMENT)

const containsHospitalLayout = (items) =>
  childrenOf(items).some(
    (item) =>
      pathOf(item).endsWith(HOSPITAL_LAYOUT_PATH) ||
      containsHospitalLayout(item?.children),
  )

const buildEntry = (neighbour) => {
  const path = pathOf(neighbour)
  const base = path.slice(0, path.indexOf(ADMIN_PANEL_SEGMENT))
  return {
    ...(neighbour.icon
      ? {
          icon: neighbour.icon,
          iconColor: neighbour.iconColor,
          iconSource: neighbour.iconSource,
          iconType: neighbour.iconType,
        }
      : { ...FALLBACK_ICON, iconColor: neighbour.iconColor }),
    access: neighbour.access || [],
    color: neighbour.color,
    groupMenuId: neighbour.groupMenuId,
    id: `${neighbour.groupMenuId || 'admin-panel'}-hospital-layout`,
    linkType: 'router',
    seq: Number(neighbour.seq || 0) + SEQ_STEP,
    title: HOSPITAL_LAYOUT_MENU_TITLE_KEY,
    type: 'item',
    url: `${base}${HOSPITAL_LAYOUT_PATH}`,
  }
}

// anchors on the Device Gateway entry (chained after it in Navigation), else
// the last admin-panel item, so it sits beside the other admin screens
const insertBelowAnchor = (items) => {
  let inserted = false
  const visit = (menuItems) => {
    const children = childrenOf(menuItems)
    const gateway = children.find((c) =>
      pathOf(c).endsWith(DEVICE_GATEWAY_PATH),
    )
    const panelItems = children.filter(isSuperAdminPanel)
    const anchor = gateway || panelItems[panelItems.length - 1]
    if (!inserted && anchor) {
      inserted = true
      const at = children.indexOf(anchor) + 1
      return [
        ...children.slice(0, at),
        buildEntry(anchor),
        ...children.slice(at),
      ]
    }
    return children.map((item) =>
      item?.children && !inserted
        ? { ...item, children: visit(item.children) }
        : item,
    )
  }
  const result = visit(items)
  return inserted ? result : null
}

/**
 * Adds the Hospital layout page to the Super Admin menu in code, for an
 * administrator only (`isAdmin` from useAuth), next to Device Gateway.
 */
export const addHospitalLayoutMenu = (items = [], { isAdmin = false } = {}) => {
  if (isAdmin !== true) return items
  if (!Array.isArray(items) || containsHospitalLayout(items)) return items
  return insertBelowAnchor(items) || items
}
